export default __webpack_public_path__ + "static/ay-support-content-operations-6a6e499d7047773b3c812c1c0698ecf2.svg";